// src/main.jsx

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider } from "@mantine/core";

import "@mantine/core/styles.css";

import App from "./App.jsx";
import "./App.css";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <MantineProvider
      defaultColorScheme="light"
      theme={{
        fontFamily:
          "Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",

        headings: {
          fontFamily:
            '"Playfair Display", Georgia, serif',
        },

        primaryColor: "pink",

        defaultRadius: "md",
      }}
    >
      <App />
    </MantineProvider>
  </StrictMode>,
);